import { useAddToWishlist, useAppDispatch, useDeleteFromWishlist, useItemInWishlists } from '@pkg/hooks';

import { CollectionChainType } from '@app/client';
import { wishlistActions } from '@app/store/slices';

export interface UseMoveToWishlistProps {
    contract?: string;
    token_id?: string;
    slug?: string;
    quantity?: number;
}

interface HandleConfirmAddToWishlistParams {
    oldWishlistSlug: string;
    newWishlistSlug: string;
    newWishlistName: string;
    callback?: () => void;
}

export const useMoveToWishlist = ({ contract, token_id, slug, quantity }: UseMoveToWishlistProps) => {
    const dispatch = useAppDispatch();

    const { mutateAsync: addToWishlist, isLoading: isLoadingAdd } = useAddToWishlist();
    const { mutateAsync: deleteFromWishlist, isLoading: isLoadingDelete } = useDeleteFromWishlist();
    const { refetch: refetchItemInWishlists } = useItemInWishlists({
        contract,
        token_id: token_id,
        slug: slug,
    });

    const handleCloseWishlistModalAfterConfirm = (newWishlistSlug: string, newWishlistName: string) => {
        dispatch(wishlistActions.setWishListModalSlug(null));
        dispatch(wishlistActions.setWishListToastSlug(newWishlistSlug));
        dispatch(wishlistActions.setWishListToastName(newWishlistName));
    };

    const handleConfirmAddToWishlist = ({
        oldWishlistSlug,
        newWishlistSlug,
        newWishlistName,
        callback,
    }: HandleConfirmAddToWishlistParams) => {
        const sharedData = { contract, token_id, slug, quantity };

        const addToNewWishlist = () => {
            addToWishlist({ ...sharedData, wishlistId: newWishlistSlug, network: CollectionChainType.Ethereum })
                .then(() => {
                    callback?.();
                    refetchItemInWishlists();
                    handleCloseWishlistModalAfterConfirm(newWishlistSlug, newWishlistName);
                })
                .catch(callback);
        };

        deleteFromWishlist({ ...sharedData, wishlistId: oldWishlistSlug, network: CollectionChainType.Ethereum })
            .then(addToNewWishlist)
            .catch(callback);
    };

    return { moveToWishlist: handleConfirmAddToWishlist, isLoading: isLoadingAdd || isLoadingDelete };
};
